import { addUserFavorites } from "@/api/user";
import { Ref } from "vue";

// Interfaces
export interface FavoriteOptions {
  userId: number | string;
  gameId: number | string;
  currentStatus: number | string;    
  loadingRef?: Ref<any>;          // optional loading screen ref
  onSuccess?: (status: number, msg?: string) => void; // callback on success
  onError?: (msg: string) => void;                    // callback on error
}

export interface GameItem {
    customIcon: string,
    id: number | string,
    gameId: number | string,
    gameMakerId: number | string,
    isFavorite: number
    activeGameId: any
}

export interface MainHeaderItem {
    url: string
    display: boolean
}

export interface DepositBtnItem {
    colorCode: string,
    display: boolean,
    redirectUrl: string
}

export interface ProfileButtonData {
    url: string,
    display: boolean,
    redirectUrl: string
}

export interface GroupListItem {
    id: number
    icon: string
    name: string
    groupType: number
}

export interface GameData {
    show : boolean
    showLoadMore : boolean
    showPopover : boolean
    groupList: GroupListItem[]
    activeItem : number | string
    gameList : GameItem[]
    loading : boolean
    balance : number
    mainHeader : MainHeaderItem
    depositButon : DepositBtnItem
    profileButtonData: ProfileButtonData
    gameCount: number
}
// Constant

export const PAGE_SIZE = 20
export const TAB_LIST = [
    { id: 1, name: 'common.toLookFor'},
    { id: 2, name: 'games.popular' },
    { id: 3, name: 'games.recent' },
    { id: 4, name: 'games.favorite' },
]
// Functions
export const toggleFavorite = async (options: FavoriteOptions) => {
  const { userId, gameId, currentStatus, loadingRef, onSuccess, onError } = options;

  if (process.env.VUE_APP_PREVIEW_MODE === 'true') return;

  // loadingRef?.value?.open?.();

  try {
    const res = await addUserFavorites({
      userId,
      gameId,
      status: currentStatus == 1 ? 0 : 1
    });

    if (res.code === 200) {
      onSuccess?.(res.data.status, res.msg);
    } else {
      onError?.(res.msg);
    }
  } catch (err: any) {
    if (err.code !== 401) onError?.(err?.message || err);
    console.error(err);
  } finally {
    // loadingRef?.value?.close?.();
  }
};